var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},_vm._l((_vm.categories),function(category){return _c('div',{key:category.id,staticClass:"shadow-md border-2 firstChild"},[_c('vue-category-sort-item',{attrs:{"category":category}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }